RivalIQ.apps.Discovery.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    function arrayCacheKeyTest(cacheValue, fetchValue) {
        cacheValue = cacheValue || [];
        fetchValue = fetchValue || [];
        return _.size(cacheValue) === _.size(fetchValue) &&
            fetchValue.sort().join('-') === cacheValue.sort().join('-');
    }

    const arrayCacheKeys = App.enums.filterableDimensionPropKeys.concat('dimensions');

    const DiscoveryCacheLayer = RivalIQ.data.BatchCacheLayer.extend({

        cacheKeys: [
            'channel',
            'searchTerm',
            'searchType',
            'property',
            'orderBy',
            'sortOrder',
            'limit',
            'minPeopleUsing',
            'followerCountLow',
            'followerCountHigh',
            'includeOtherBucket',
            'notableUsageAmount'
        ].concat(_.map(arrayCacheKeys, function (arrayCacheKey) {
            return {
                value: arrayCacheKey,
                test: arrayCacheKeyTest
            };
        })),

        loadData: function (requests) {
            const me = this;

            // NOTE: all requests have to be for the same channel.
            const channel = _.get(requests, ['0', 'channel']);
            const collection = new me.Collection(null, {
                channel: channel
            });

            const data = _.map(requests, function (request) {
                return _.extend({},
                    _.pick(request, me.cacheKeys),
                    _.pick(request, arrayCacheKeys)
                );
            });

            return collection.fetch({
                data: data
            });
        },

        fetch: function (params) {
            const me = this;

            // quick normalization step -- if the request has no free dimensions,
            // sorting/limiting doesn't make any sense.
            if (_.isEmpty(RivalIQ.metric.getFreeDimensions(params))) {
                params = _.omit(params, ['sortOrder', 'orderBy', 'limit']);
            }

            return me.getOrLoad(params);
        }
    });

    const Discovery = DiscoveryCacheLayer.extend({
        name: 'Discovery',
        Collection: App.collections.DiscoveryCollection
    });

    data.discovery = new Discovery();
});
